exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-zone[data-v-4437c5d2] {\n  position: relative;\n}\n.upload-zone h2[data-v-4437c5d2] {\n    text-align: center;\n    font-weight: 300;\n}\n.upload-zone p[data-v-4437c5d2] {\n    margin: 0px 0px;\n}\n.upload-zone input[data-v-4437c5d2] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    cursor: pointer;\n    opacity: 0;\n}\n", ""]);

// exports
